import { Context, createContext, FC, useContext } from "react";
import { isBrowser } from "utils/nookies/utils";

type AgentContext = { userAgent: string };

interface AgentContextValues {
  deviceAppStore: DeviceAppStore;
  userAgent: string;
}

export const enum DeviceAppStore {
  AppStore = "appStore",
  GooglePlay = "googlePlay",
  AppGallery = "appGallery",
  GooglePlay_AppGallery = "googlePlay_appGallery",
}

export const AgentContext: Context<AgentContextValues> = createContext(
  {} as AgentContextValues
);

export function useGetDeviceAppStore(): DeviceAppStore {
  return useContext(AgentContext).deviceAppStore;
}

export function useGetDeviceAppStoreClientSide(): DeviceAppStore|null {
  if (!isBrowser()) return null;
  const ua = navigator?.userAgent?.toLowerCase();
  if (ua.includes("iphone") || ua.includes("ipad")) {
    return DeviceAppStore.AppStore;
  }
  return DeviceAppStore.GooglePlay_AppGallery;
}

export function useGetDeviceUserAgent(): string {
  return useContext(AgentContext).userAgent;
}

const AgentContextProvider: FC<AgentContext> = ({ children, userAgent }) => {
  function setDeviceAppStore(): DeviceAppStore {
    let device: DeviceAppStore;
    if (/iPhone|iPad|iPod/i.test(userAgent)) device = DeviceAppStore.AppStore;
    else if (/huawei/i.test(userAgent)) device = DeviceAppStore.AppGallery;
    else device = DeviceAppStore.GooglePlay_AppGallery;

    return device;
  }

  const deviceAppStore = setDeviceAppStore();

  return (
    <AgentContext.Provider value={{ deviceAppStore, userAgent }}>
      {children}
    </AgentContext.Provider>
  );
};

export default AgentContextProvider;
